import LocationCard from './LocationCard';

export { type LocationCardProps } from './LocationCard';
export default LocationCard;
